module.exports = __webpack_public_path__ + "img/halloween_ghost.33ec3058.svg";